import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20warm%20community%20gathering%20space%20with%20abstract%20geometric%20shapes%2C%20soft%20warm%20orange%20and%20cream%20color%20palette%2C%20cozy%20atmosphere%2C%20people%20connecting%20and%20chatting%20in%20a%20modern%20environment%2C%20stylized%20artistic%20illustration%2C%20clean%20minimal%20aesthetic%2C%20high%20quality%20digital%20art&width=1600&height=900&seq=yipinlou-hero-2026&orientation=landscape"
        alt="一品楼论坛社区交流"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 font-heading tracking-wide">
          一品楼论坛
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          汇聚优质内容的综合性交流社区。在这里，与数万名活跃用户共享精彩内容，畅享高品质社区体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-6 py-3 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即加入
          </Link>
          <Link
            to="/category/tech-discussion"
            className="px-6 py-3 rounded-lg text-sm font-medium bg-background-50/20 text-white border border-white/30 hover:bg-background-50/30 transition-colors whitespace-nowrap backdrop-blur-sm"
          >
            浏览内容
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">50,000+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">注册会员</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">120,000+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">优质帖子</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">8</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">主题分类</div>
          </div>
        </div>
      </div>
    </section>
  );
}